import React from 'react';
import OptionButton from '../OptionButton';

const Step4 = ({ data, onSelect, overrides }) => {
  const options = overrides?.options || [
    'Energy and stamina',
    'Metabolism and weight balance',
    'Hair, skin, and nails',
    'Mood and mental clarity',
    'Other'
  ];

  const toggleSelection = (option) => {
    const currentSelections = data.supportAreas || [];
    const isSelected = currentSelections.includes(option);
    
    let newSelections;
    if (isSelected) {
      newSelections = currentSelections.filter(item => item !== option);
    } else {
      newSelections = [...currentSelections, option];
    }
    
    onSelect('supportAreas', newSelections);
  };

  const isSelected = (option) => {
    return (data.supportAreas || []).includes(option);
  };

  return (
    <div className="flex flex-col">
      {/* Question */}
      <h1 className="font-serif text-4xl md:text-5xl leading-tight mb-3" style={{ color: '#1a1a2e' }}>
        {overrides?.question || 'Besides thyroid health, what areas do you need the most support in?'}
      </h1>
      
      {/* Subtext */}
      <p className="text-base mb-8" style={{ color: '#666' }}>
        {overrides?.subtitle || 'Select all that apply.'}
      </p>

      {/* Options */}
      <div className="flex flex-col gap-3 items-start">
        {options.map((option) => (
          <OptionButton
            key={option}
            selected={isSelected(option)}
            onClick={() => toggleSelection(option)}
          >
            {option}
          </OptionButton>
        ))}
      </div>
    </div>
  );
};

export default Step4;
